var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustryLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615",
    transform: "translate(-340 -1426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(340 1426)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Idea",
    transform: "translate(354.715 1437.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M18.433,6.542H18.4A11.5,11.5,0,0,0,10.064,25.97,5.44,5.44,0,0,1,11.652,29.7v.971a2.406,2.406,0,0,0,2.4,2.4h8.714a2.4,2.4,0,0,0,2.4-2.4V29.7a5.44,5.44,0,0,1,1.589-3.734A11.5,11.5,0,0,0,18.433,6.542ZM25.116,24.4A7.7,7.7,0,0,0,22.895,29.7v.971a.127.127,0,0,1-.126.126H14.054a.127.127,0,0,1-.126-.126V29.7A7.7,7.7,0,0,0,11.707,24.4,9.229,9.229,0,0,1,18.4,8.817a.237.237,0,0,0,.03,0A9.226,9.226,0,0,1,25.116,24.4Z",
    transform: "translate(1.221 1.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M15.752,10.7a6.432,6.432,0,0,0-4.7,4.728,1.138,1.138,0,0,0,.835,1.376,1.111,1.111,0,0,0,.272.033,1.139,1.139,0,0,0,1.1-.869A4.212,4.212,0,0,1,16.3,12.908a1.139,1.139,0,0,0-.55-2.21Z",
    transform: "translate(2.312 2.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M19.994,29.1h-6.21a1.138,1.138,0,1,0,0,2.277h6.21a1.138,1.138,0,1,0,0-2.277Z",
    transform: "translate(2.744 7.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    transform: "translate(2.285 1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M16.238,5.605a1.138,1.138,0,0,0,1.138-1.138V2.238a1.138,1.138,0,0,0-2.277,0V4.467A1.138,1.138,0,0,0,16.238,5.605Z",
    transform: "translate(1.109 -1.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M29.52,12.909H27.291a1.138,1.138,0,0,0,0,2.277H29.52a1.138,1.138,0,0,0,0-2.277Z",
    transform: "translate(4.037 2.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M5.651,12.909H3.423a1.138,1.138,0,1,0,0,2.277H5.652a1.138,1.138,0,1,0,0-2.277Z",
    transform: "translate(-2.285 2.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M8.659,8.078A1.139,1.139,0,0,0,10.27,6.469L8.693,4.892A1.138,1.138,0,0,0,7.083,6.5Z",
    transform: "translate(-1.103 -0.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M24.114,4.892,22.538,6.468a1.139,1.139,0,0,0,1.611,1.609L25.725,6.5a1.139,1.139,0,1,0-1.611-1.609Z",
    transform: "translate(2.991 -0.184)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryLearning);
export default __webpack_public_path__ + "static/media/industry-learning.bea9f535a5400829ce7592a44ceea537.svg";
export { ForwardRef as ReactComponent };